"use client";

import { IIpoListAPIResponse } from "../../interfaces/IpoList.interface";
import { IpoAuthoringDataType } from "../IpoBase/IpoBaseAuthoringType";
import IpoListWrapper from "../IpoList/IpoListWrapper";
import IpoTitle from "../IpoTitleWithDescription/IpoTitle";

type CurrentIPOClientProps = {
  mainboardInitial: IIpoListAPIResponse;
  smeInitial: IIpoListAPIResponse;
  authoringData?: IpoAuthoringDataType;
};

const CurrentIPOClient = ({
  mainboardInitial,
  smeInitial,
  authoringData,
}: CurrentIPOClientProps) => {
  const componentLink = authoringData?.componentLink || "current-ipo";

  return (
    <div className={`${componentLink}`}>
      <IpoTitle
        ipoTitle={authoringData?.ipoTitle ?? "current-ipo"}
        ipoDescription={authoringData?.signInText}
        ipoType={authoringData?.ipoType ?? "current"}
        defaultVariant={false}
        mainboardCount={mainboardInitial.data.totalcount}
        smeCount={smeInitial.data.totalcount}
      />
      <IpoListWrapper
        componentLink={componentLink}
        ipoTitle={authoringData?.ipoTitle ?? "Current IPO"}
        mainboardTitle={authoringData?.mainboardTitle ?? "Mainboard"}
        smeTitle={authoringData?.smeTitle ?? "SME"}
        viewAllText={authoringData?.viewAllText ?? "View all"}
        biddingPeriodText={authoringData?.biddingPeriodText ?? "Bidding period"}
        minimumInvestmentText={
          authoringData?.minimumInvestmentText ?? "Minimum investment"
        }
        bidPriceText={authoringData?.bidPriceText ?? "Issue price"}
        listingDateText={authoringData?.listingDateText ?? "Listing date"}
        listingGainText={authoringData?.listingGainText ?? "Listing gain"}
        pageType={authoringData?.pageType ?? "current-ipo"}
        showMoreCtaText={authoringData?.showMoreCtaText ?? "Show more"}
        paginationLimit={authoringData?.paginationLimit ?? "20"}
        ipoType={authoringData?.ipoType ?? "current"}
        apiErrorDesc={authoringData?.apiErrorDesc ?? "No current IPOs found."}
        fetchApiDataErrorDesc={
          authoringData?.fetchApiDataErrorDesc ??
          "Unable to fetch current IPOs right now."
        }
        tbaText={authoringData?.tbaText ?? "TBA"}
        signInText={authoringData?.signInText}
        redirectToPdpBaseUrl={authoringData?.redirectToPdpBaseUrl}
        viewAllRedirectUrl={authoringData?.viewAllRedirectUrl}
        mainboardInitial={mainboardInitial}
        smeInitial={smeInitial}
      />
    </div>
  );
};

export default CurrentIPOClient;
